module.exports = __webpack_public_path__ + "img/overview.cbf12e59.png";